import React from 'react'
import SunDashboard from '@/components/sun/SunDashboard'

/**
 * "Pause deliveries", on its own route.
 *
 * The same calendar the desktop rail opens as a dialog, rendered as a full page
 * for the mobile bottom nav. Renders SunDashboard in `pause` view so it shares
 * the same deliveries and save logic rather than duplicating them; SunDashboard
 * owns its own loading and data, so there is nothing to gate here.
 */
function PauseDeliveries(): React.JSX.Element {
  return (
    <div className="dashboard">
      <SunDashboard view="pause" />
    </div>
  )
}

export default PauseDeliveries
